import styled from 'styled-components'
import {
	STRONGORANGE,
	MEDIUMGRAY,
	DARKGRAY,
	CLEARGRAY,
	GREEN,
} from '../../../../../../styles/colors.style'
import { breakpoints } from '../../../../../../constants'

export const ContainerTable = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`

export const TablePayment = styled.table`
	display: none;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: table;
		border-collapse: collapse;
		width: 100%;
	}

	.mw-50 {
		min-width: 50px !important;
	}

	th {
		color: ${MEDIUMGRAY};
		font: 13px/16px 'Source Sans Pro';
		text-align: left;
		border-bottom: 1px solid ${CLEARGRAY};
		padding: 10px 0;

		&:first-child {
			width: 100px;
		}

		&:last-child {
			text-align: right;
		}
	}

	tbody {
		font: 600 15px/19px 'Source Sans Pro';
		td {
			color: ${DARKGRAY};
			padding: 10px 0;
			border-bottom: 1px solid ${CLEARGRAY};

			&:first-child {
				font-size: 12px;
				font-weight: 600;
				color: ${STRONGORANGE};
			}
			&:last-child {
				text-align: right;
				font-weight: 600;
				min-width: 75px;
				&.trCredit::before,
				&.trPayment::before {
					content: ' - ';
				}
			}
		}
		.trCredit,
		.trPayment {
			color: ${GREEN} !important;
		}
	}
`

export const FooterPayment = styled.div`
	flex: 1;
	justify-content: unset;
	align-items: flex-end;
	display: flex;
	padding: 23px 0;
	color: ${MEDIUMGRAY};
`

export const Info = styled.small`
	color: ${STRONGORANGE};
	text-transform: uppercase;
	font: 600 10px/13px 'Source Sans Pro';
`
